import { observer } from "mobx-react";
import { isMobileView } from "@/utils/screen";
import { MTextInput } from "@/components-v2/TextInput";
import { Box, Container } from "@/components-v2/Box";
import { useTranslation } from "@/stores/RootStoreContext";
import { MSelect } from "@/components-v2/Select";
import { DataTable, TableColumn } from "@/components-v2/DataTable";
import { Checkbox } from "@/components-v2/Checkbox";
import {
  companyRolesCompanies,
  companyRolesEmail,
  companyRolesPhoneNumber,
  companyRolesRoleType,
  CompanyRolesViewProps,
  filterCompanyRoleRows,
} from "./companyRolesDomain";
import { AggregatedContactItem } from "./contactsDomain";
import { TextWithTooltip } from "@/components-v2/TextWithTooltip";

export const CompanyRolesView = observer((props: CompanyRolesViewProps) => {
  const { t } = useTranslation();
  const columns: TableColumn<AggregatedContactItem>[] = [
    {
      name: "name",
      label: t("name"),
      align: "left",
      getValue: (row) => row.name,
      getSortValue: (row) => row.name,
    },
    {
      name: "role",
      label: t("role"),
      align: "left",
      getValue: (row) => <TextWithTooltip {...companyRolesRoleType(row.roleItems)} />,
      getSortValue: (row) => t(companyRolesRoleType(row.roleItems).text),
    },
    {
      name: "companies",
      label: t("portfolioContacts.companies"),
      align: "left",
      getValue: (row) => <TextWithTooltip {...companyRolesCompanies(row.roleItems)} />,
      getSortValue: (row) => t(companyRolesCompanies(row.roleItems).text),
    },
    {
      name: "email",
      label: t("email"),
      align: "left",
      getValue: (row) => <TextWithTooltip {...companyRolesEmail(row.roleItems)} />,
      getSortValue: (row) => t(companyRolesEmail(row.roleItems).text),
    },
    {
      name: "phoneNumber",
      label: t("contacts.company-roles.phone-number"),
      align: "left",
      getValue: (row) => <TextWithTooltip {...companyRolesPhoneNumber(row.roleItems)} />,
      getSortValue: (row) => t(companyRolesPhoneNumber(row.roleItems).text),
    },
  ];
  return (
    <Container padding maxWidth="xl">
      <Box vertical={isMobileView()} className={"self-start"} alignItems={"center"}>
        {props.roleNameFilter && (
          <MTextInput
            model={props.roleNameFilter}
            icon={"magnifying-glass"}
            placeholder={t("portfolioContacts.nameFilterPlaceholder")}
            type={"search"}
          />
        )}
        {props.selectedCompany && <MSelect model={props.selectedCompany} />}
        {props.selectedRoleType && <MSelect model={props.selectedRoleType} />}
        <Box marginLeft={isMobileView() ? undefined : "lg"}>
          <Checkbox
            checked={props.filterMissingEmailModel?.value}
            label={props.filterMissingEmailLabel}
            disabled={props.isFilterMissingEmailDisabled}
            onChange={(e) => props.filterMissingEmailModel?.setValue(e.target.checked)}
          />
        </Box>
      </Box>
      <DataTable
        variant={"LARGE"}
        tableColumns={columns}
        tableData={filterCompanyRoleRows(
          props.selectedCompany?.value,
          props.selectedRoleType?.value,
          props.aggregatedPersonItems,
          props.roleNameFilter?.inputValue,
          props.filterMissingEmailModel?.value,
        )}
        getId={(row) => row.aggregatedContactId}
        initialSortBy={"name"}
        initialSortDirection={"asc"}
        onRowClick={(row) => props.navigateToDetails(row.aggregatedContactId)}
        rowActions={props.rowActions}
      />
    </Container>
  );
});
